export default __webpack_public_path__ + "static/img/43.2fb8de3.png";